<template>

    <div class="last_positions_wrap">

        <div class="evals_head_list">
            <div class="last_positions_label">
                <iconPosition /> <span>{{ $t('modules.dashboard.lastPositions.title') }}</span>

            </div>
        </div>

        <div class="last_positions_list" v-if="currentList.length > 0">
            <LastPositionsItem v-for="(position, index) in currentList" :key="position.id" :index="index" :position="position" />
        </div>
        <div class="last_positions_no_items" v-else>
            <div>{{ $t('modules.dashboard.lastPositions.noPositionYet') }}</div>
        </div>
    </div>

</template>

<script>
import LastPositionsItem from './lastPositionsItem'

export default {
    name: 'LastEvalsWrap',
    components: {
        LastPositionsItem
    },
    data(){
        return {
            selectedTab: 'completed'
        }
    },
    computed: {
        currentList(){
            return this._.orderBy(this.$store.state.PositionStore.positionsList, ['created_at'], ['desc']).slice(0, 4)
        }
    },
    methods: {
    }
}


</script>

<style lang="scss">
.last_positions_wrap{
    .evals_head_list{
        display: flex;
        border-bottom: 1px solid $grey-lighter;
        .last_positions_label{
            font-weight: 600;
            font-size: 1.15rem;
            padding: 12px 16px;
            display: flex;
            align-items: center;
            text-transform: uppercase;
            svg{
                height: 24px;
                margin-right: 12px;
                fill: $grey;
            }
        }
        .evals_tabs{
            display: flex;
            & > div{
                display: flex;
                align-items: center;
                padding: 12px 16px;
                border-bottom: 4px solid rgba(0,0,0,0);
                cursor: pointer;
                user-select: none;
                text-transform: uppercase;
                .completed_mark{
                    margin-right: 8px;
                }
                &:hover{
                    border-color: $grey-lighter;
                }
                &.active{
                    border-color: $info;
                }
            }
        }
    }
    .last_positions_no_items{
        font-size: 1.2rem;
        padding: 15px;
        background-color: $white-ter;
        border-bottom: 1px solid $grey-lighter;
    }
}
</style>